import React, { useState, useEffect } from "react";
import { Form } from "react-bootstrap";
import api from "../axiosConfig";

const RegistrarAcompanante = () => {
  const [citaId, setCitaId] = useState("");
  const [citasSelect, setCitasSelect] = useState([]);
  const [citasTabla, setCitasTabla] = useState([]);
  const [nombre, setNombre] = useState("");
  const [apellidos, setApellidos] = useState("");
  const [identificacion, setIdentificacion] = useState("");
  const [motivoId, setMotivoId] = useState("");
  const [nuevoMotivo, setNuevoMotivo] = useState("");

  const [acompanantes, setAcompanantes] = useState([]);
  const [total, setTotal] = useState(0);
  const [citas, setCitas] = useState([]);
  const [motivos, setMotivos] = useState([]);
 

  const [filtro, setFiltro] = useState("");
  const [filtroAcompanantes, setFiltroAcompanantes] = useState("");
 
  const [editandoId, setEditandoId] = useState(null);

  const [pagina, setPagina] = useState(1);
  const porPagina = 20;

  //alertas
  const [mensaje, setMensaje] = useState(null);
  const mostrarMensaje = (tipo, texto) => {
    setMensaje({ tipo, texto });
    setTimeout(() => setMensaje(null), 4000); // se oculta en 4s
  };

  useEffect(() => {
    fetchAcompanantes();
    }, [pagina, filtroAcompanantes]);

    useEffect(() => {
    fetchCitas();
    fetchMotivos();
  }, []);

  const fetchAcompanantes = async () => {
    try {
      const skip = (pagina - 1) * porPagina;
      const params = {
        skip,
        limit: porPagina,
      };
      if (filtro.trim()) {
        params.buscar = filtroAcompanantes;
      }

      const response = await api.get("/acompanantes/", {
        params,
      });
      setAcompanantes(response.data.resultados);
      setTotal(response.data.total);
    } catch (error) {
      console.error("Error al obtener acompañantes:", error);
    }
  };

  const fetchCitas = async () => {
  try {
    const response = await api.get("/citas/");
    const todasLasCitas = response.data.resultados || response.data;

    // TABLA: usar todas las citas sin filtro
    setCitasTabla(todasLasCitas);
     // SELECT: solo citas del año actual
    const añoActual = new Date().getFullYear();
    const citasDelAñoActual = todasLasCitas.filter((cita) => {
      const añoCita = new Date(cita.fecha).getFullYear();
      return añoCita === añoActual;
    });
    setCitasSelect(citasDelAñoActual);
  } catch (error) {
    console.error("Error al obtener citas:", error);
  }
};

  const fetchMotivos = async () => {
    try {
      const response = await api.get("/motivos/");
      setMotivos(response.data);
    } catch (error) {
      console.error("Error al obtener motivos:", error);
    }
  };

  const crearNuevoMotivo = async () => {
    const res = await api.post("/motivos", {
      motivo: nuevoMotivo,
    });
    return res.data.id;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      let motivoFinalId = motivoId;

      if (motivoId === "otro" && nuevoMotivo.trim()) {
        motivoFinalId = await crearNuevoMotivo();
        await fetchMotivos();
      }

      const data = {
        nombre: nombre,
        identificacion: identificacion,
        cita_id: parseInt(citaId),
        tipo_cliente_id: 1,
        nombres: nombre,
        apellidos: apellidos || "",
        motivo_id: motivoFinalId ? parseInt(motivoFinalId): null,
      };

      if (editandoId) {
        await api.put(`/acompanantes/${editandoId}`, data);
        mostrarMensaje("success", "Acompañante actualizado correctamente");
      } else {
        await api.post("/acompanantes/", data);
        mostrarMensaje("success", "Acompañante registrado correctamente");
      }

      fetchAcompanantes();
      setCitaId("");
      setNombre("");
      setApellidos("");
      setIdentificacion("");
      setMotivoId("");
      setNuevoMotivo("");
      setEditandoId(null);

    } catch (error) {
    if (error.response) {
      // Aquí manejamos errores específicos del backend
      if (error.response.status === 400 && error.response.data.detail.includes("ya está registrado")) {
        mostrarMensaje("warning", "Este acompañante ya existe para la cita seleccionada");
      } else {
        mostrarMensaje("danger", `Error: ${error.response.data.detail || "Error al guardar el acompañante"}`);
      }
    } else {
      console.error("Error al guardar el acompañante:", error.message);
      mostrarMensaje("danger", "Error de conexión o servidor");
    }
  }
};

  
 

  const handleEditar = (acompanante) => {
    setCitaId(acompanante.cita_id);
    setNombre(acompanante.nombre);
    setApellidos(acompanante.apellidos || "");
    setIdentificacion(acompanante.identificacion);
    setMotivoId(acompanante.motivo_id || "");
    setEditandoId(acompanante.id);
  };

  const handleEliminar = async (id) => {
    if (!window.confirm("¿Estás seguro de eliminar este acompañante?")) return;
    try {
      await api.delete(`/acompanantes/${id}`);
      mostrarMensaje("danger", "Acompañante eliminado correctamente");
      fetchAcompanantes();
    } catch (error) {
      console.error("Error al eliminar el acompañante:", error);
    }
  };

  const totalPaginas = Math.ceil(total / porPagina);

  const citasFiltradas = citas.filter((cita) => {
    const nombreCompleto = `${cita.cliente?.nombres || ""} ${cita.cliente?.apellidos || ""}`.toLowerCase();
    const documento = cita.cliente?.doc_identificacion?.toLowerCase() || "";
    const buscar = filtro.toLowerCase();
    return nombreCompleto.includes(buscar) || documento.includes(buscar);
  });

  const acompanantesFiltrados = acompanantes.filter((a) => {
  const nombreCompleto = `${a.nombre || ""} ${a.apellidos || ""}`.toLowerCase();
  return nombreCompleto.includes(filtroAcompanantes.toLowerCase());
});


  return (
   <div className="card p-4">
  <h3 className="text-primary">
    {editandoId ? "Lista de Acompañantes" : "Registrar Acompañante"}
  </h3>
   {mensaje && (
  <div className={`alert alert-${mensaje.tipo} mt-3`} role="alert">
    {mensaje.texto}
  </div>
)}
  <form onSubmit={handleSubmit} className="mt-3">

    {/* FILA 1: Filtro y Cita */}
    <div className="row mb-3">
      <div className="col-md-4">
        <input
          type="text"
          value={filtro}
          onChange={(e) => {
            setFiltro(e.target.value);
            setPagina(1);
          }}
          placeholder="Buscar por nombre o documento"
          className="form-control form-control-sm"
        />
      </div>

      <div className="col-md-4">
        <select
          value={citaId}
          onChange={(e) => setCitaId(e.target.value)}
          className="form-select form-select-sm"
          required
        >
          <option value="">Seleccione una cita</option>
          {citasSelect
  .filter((cita) => {
    const nombreCompleto = `${cita.cliente?.nombres || ""} ${cita.cliente?.apellidos || ""}`.toLowerCase();
    const documento = cita.cliente?.doc_identificacion?.toLowerCase() || "";
    const buscar = filtro.toLowerCase();

    return (
      nombreCompleto.includes(buscar) ||
      documento.includes(buscar)
    );
  })
  .map((cita) => (
            <option key={cita.id} value={cita.id}>
              {`${cita.cliente?.nombres || ""} ${cita.cliente?.apellidos || ""}`} - {cita.fecha} {cita.hora} (ID: {cita.id})
            </option>
          ))}
        </select>
      </div>
    </div>

    {/* FILA 2: Nombre, Apellidos, Identificación */}
    <div className="row mb-3">
      <div className="col-md-4">
        <input
          type="text"
          value={nombre}
          onChange={(e) => setNombre(e.target.value)}
          placeholder="Nombres del Acompañante"
          className="form-control form-control-sm"
          required
        />
      </div>
      <div className="col-md-4">
        <input
          type="text"
          value={apellidos}
          onChange={(e) => setApellidos(e.target.value)}
          placeholder="Apellidos del Acompañante"
          className="form-control form-control-sm"
        />
      </div>
      <div className="col-md-4">
        <input
          type="text"
          value={identificacion}
          onChange={(e) => setIdentificacion(e.target.value)}
          placeholder="Identificación"
          className="form-control form-control-sm"
          required
        />
      </div>
    </div>

    {/* FILA 3: Motivo */}
    <div className="row mb-3">
      <div className={motivoId === "otro" ? "col-md-4" : "col-md-4"}>
        <select
          className="form-select form-select-sm"
          value={motivoId}
          onChange={(e) => setMotivoId(e.target.value)}
          required
        >
          <option value="">Seleccione un motivo</option>
          {motivos.map((motivo) => (
            <option key={motivo.id} value={motivo.id}>
              {motivo.motivo}
            </option>
          ))}
          <option value="otro">Otro (escribir nuevo)</option>
        </select>
      </div>
      {motivoId === "otro" && (
        <div className="col-md-8">
          <input
            type="text"
            value={nuevoMotivo}
            onChange={(e) => setNuevoMotivo(e.target.value)}
            placeholder="Ingrese nuevo motivo"
            className="form-control form-control-sm"
            required
          />
        </div>
      )}
    </div>

  
  
         <div>
          <button type="submit" className="btn btn-primary">
            {editandoId ? "Actualizar Acompañante" : "Agregar Acompañante"}
          </button>
       
  <button
    type="button"
    className="btn btn-secondary ms-2"
    onClick={() => {
      setCitaId("");
      setNombre("");
      setApellidos("");
      setIdentificacion("");
      setMotivoId("");
      setNuevoMotivo("");
      setEditandoId(null);
    }}
  >
    Cancelar
  </button>
       
  </div>
        
      </form> 
  
      <div className="mt-3">
       <h5 className="text-lg font-semibold mb-2">Lista de Acompañantes</h5>
 
 
<Form.Control
  type="text"
  placeholder="Buscar por nombre o apellido"
  value={filtroAcompanantes}
  onChange={(e) => {
    setPagina(1);
    setFiltroAcompanantes(e.target.value);
  }}
  className="form-control dorm-control-sm w-auto mb-3"
   
/>

<table className="table table-bordered table-striped"
style={{ tableLayout: "auto", width: "auto", whiteSpace: "nowrap" }}>
  <thead >
    <tr>
      
      <th>ID</th>
      <th>Nombre del Acompañante</th>
      <th>Cita ID</th>
      <th>Cliente Principal</th>
      <th>Acciones</th>
    </tr>
  </thead>
  <tbody>
    {acompanantesFiltrados.map((a) => {
      const cita = citasTabla.find((c) => c.id === a.cita_id);
      const cliente = cita?.cliente;
      return (
        <tr key={a.id}>
          <td>{a.id}</td>
          <td>{a.nombre}</td>
          <td>{a.cita_id}</td>
          <td>{cliente ? `${cliente.nombres || ""} ${cliente.apellidos ||""}` : "No disponible"}</td>
          <td>
            <button onClick={() => handleEditar(a)} className="btn btn-sm "
              style={{ backgroundColor: "#4e73df", borderColor: "#1cc88a", color: "#fff" }}>
              ✏ Editar
            </button>
            {/*<button onClick={() => handleEliminar(a.id)} className="btn btn-sm btn-danger">
              🗑 Eliminar
            </button>*/}
          </td>
        </tr>
      );
    })}
  </tbody>
</table>
           
      
        <div className="d-flex justify-content-between align-items-center mt-3">
          <button
            variant="secondary" disabled={pagina === 1} onClick={() => setPagina(p => p - 1)}
          >
            ← Anterior
          </button>
          <span > Página {pagina} de {totalPaginas}</span>
          
          <button
            variant="secondary" disabled={pagina === totalPaginas} onClick={() => setPagina(p => p + 1)}
          >
            Siguiente →
          </button>
        </div>
      </div>
    </div>
  );
};

export default RegistrarAcompanante;
